// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"MainPage_mainDiv__10D_N","texto":"MainPage_texto__3Dp1n","abogados":"MainPage_abogados__14Bw8"};